import { AiBlocks } from '@pendo/services/BuildingBlocks';
import { createLightboxStepTemplate, createFirstArtifactStep } from './steps-template';
import get from 'lodash/get';

export function createGeneratedAnnouncementTemplate ({ theme, generatedSteps, steps }) {
    const newSteps = generatedSteps.map((step, index) => {
        return createFirstStepAnnouncementTemplate({
            theme,
            stepArtifact: step,
            stepBlocks: get(steps, `[${index}].buildingBlocks`),
        });
    });

    return AiBlocks.prepStepsForPreview(newSteps, steps, theme);
}

function createFirstStepAnnouncementTemplate ({ theme, stepArtifact, stepBlocks }) {
    return createLightboxStepTemplate({ theme, width: 600, stepArtifact, stepBlocks });
}

export function createArtifactStepsFromAnnouncementTemplate () {
    return [createFirstArtifactStep()];
}
